import { ChakraProvider } from '@chakra-ui/react';
import { ApolloClient, InMemoryCache, ApolloProvider, ApolloLink, HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import './App.scss';
import { AuthProvider } from './context/AuthContext';
import theme from './utils/ChakraTheme';
import AppRouter from './AppRouter';
import { getAuthHeader } from './utils/auth-token';

const apolloClient = new ApolloClient({
	link: ApolloLink.from([
		setContext((_, { headers }) => ({ headers: { ...headers, ...getAuthHeader() } })),
		new HttpLink({ uri: process.env.REACT_APP_APOLLO_URL }),
	]),
	cache: new InMemoryCache(),
	defaultOptions: {
		watchQuery: { fetchPolicy: 'no-cache', errorPolicy: 'ignore' },
		query: { fetchPolicy: 'no-cache', errorPolicy: 'all' },
	},
});

export default function App() {
	return (
		<ChakraProvider theme={theme} resetCSS={false}>
			<AuthProvider>
				<ApolloProvider client={apolloClient}>
					<AppRouter />
				</ApolloProvider>
			</AuthProvider>
		</ChakraProvider>
	);
}
